'use client';

import { ReactElement } from 'react';
import { AbsoluteFill, Sequence } from 'remotion';

// Components
import { WavyLinesBackground } from '@/components/common/WavyLinesBackground';
import { MainContent } from './components/MainContent';

// Themes
import { employeeYearInReviewTheme } from '@/components/EmployeeYearInReview/theme';

// Utils
import { combineClasses } from '@/utils';

// Types
import { TrainingFeedbackData } from './types';

export interface Scene5cProps {
  /** Delay in frames before animations start (for transition overlap) */
  animationDelay?: number;
  /** Training feedback data */
  trainingFeedbacks?: TrainingFeedbackData[];
}

/**
 * Scene 5c: Training feedback scene with animated wavy lines
 */
export const Scene5c = ({
  animationDelay = 0,
  trainingFeedbacks,
}: Scene5cProps): ReactElement => {
  const { colors } = employeeYearInReviewTheme;

  return (
    <AbsoluteFill>
      <Sequence name="Background">
        <AbsoluteFill className={combineClasses(colors.bgSecondary)}>
          <WavyLinesBackground
            textEntrance={{ startFrame: 5, charStagger: 3, slideDistance: 50 }}
          />
        </AbsoluteFill>
      </Sequence>

      <MainContent
        animationDelay={animationDelay}
        feedbacks={trainingFeedbacks}
      />
    </AbsoluteFill>
  );
};
